class VmtHelper {
  constructor() { }

  registerCanvases(base_canvas_id, display_canvas_id, resize_canvas_id) {
    /**
     * base_canvas_id is the id of canvas which the video or image in written to
     * while the display_canvas_id is the id of canvas to which you would like to
     * write the resulting image
     */
    try {
      this.base_canvas = document.getElementById(base_canvas_id);
      this.base_ctx = this.base_canvas.getContext("2d");
    } catch (error) {
      console.log("no such base canvas found");
      return false;
    }

    try {
      this.display_canvas = document.getElementById(display_canvas_id);
      this.display_ctx = this.display_canvas.getContext("2d");
    } catch (err) {
      console.log("no such display canvas found");
      return false;
    }

    try {
      this.resize_canvas = document.getElementById(resize_canvas_id);
      this.resize_ctx = this.resize_canvas.getContext("2d");
    } catch (err) {
      console.log("no such resize canvas found");
      return false;
    }

    return true;
  }

  clearCanvases() {
        if (document.getElementById('tryon-live-canvas-0').toDataURL() != document.getElementById('empty-canvas').toDataURL()) {
            this.base_ctx.clearRect(0, 0, this.base_canvas.width, this.base_canvas.height);
            this.resize_ctx.clearRect(0, 0, this.resize_canvas.width, this.resize_canvas.height);
            if(this.isLive)
                this.display_ctx.clearRect(0, 0, this.resize_canvas.width, this.resize_canvas.height);
            else
                this.display_ctx.clearRect(0, 0, this.display_canvas.width, this.display_canvas.height);
        }
    }

  setLive(bool) {
    this.isLive = bool;
  }

   cycleForLive() {
    let width = this.base_canvas.width;
    let height = this.base_canvas.height;

    let image_data = this.base_ctx.getImageData(0, 0, width, height);
    let wasm_input_buffer = _arrayToHeap(image_data.data);

    if (wasm_input_buffer === undefined) {
      console.warn("frame is skipping");
      return;
    }

    vmt_module._landmarkDetectionFullLifeCycle(
      width,
      height,
      wasm_input_buffer.byteOffset,
      wasm_input_buffer.byteOffset
    );

    try {
      image_data.data.set(wasm_input_buffer);

      this.resize_canvas.width = width;
      this.resize_canvas.height = height;
      this.resize_ctx.clearRect(0, 0, width, height);
      this.resize_ctx.putImageData(image_data, 0, 0);

      let isMobileBrowser = window.VmtHelper.CheckMobileBrowser();
      let outputWidth, outputHeight;
      if (isMobileBrowser) {
        outputWidth = window.TryOnEnums.OUTPUT_CANVAS_WIDTH_MOBILE;
      } else {
        outputWidth = window.TryOnEnums.OUTPUT_CANVAS_WIDTH_DESKTOP;
      }

      let aspectRatio = height / width;
      outputHeight = outputWidth * aspectRatio;

      let resizeFactor;
      resizeFactor = outputWidth / width;

      this.display_canvas.width = outputWidth;
      this.display_canvas.height = outputHeight;
      this.display_ctx.clearRect(0, 0, width, height);
      this.display_ctx.scale(resizeFactor, resizeFactor);
      this.display_ctx.drawImage(this.resize_canvas, 0, 0);
    } catch (err) {
      console.warn("unable to set image to display canvas");
      return;
    }

    _freeArray(wasm_input_buffer);
  }

  cycleForSingleImage(render_only = false) {
    if (this.isLive === true) return;

    let width = this.base_canvas.width;
    let height = this.base_canvas.height;

    let image_data = this.base_ctx.getImageData(0, 0, width, height);
    let wasm_input_buffer = _arrayToHeap(image_data.data);

    if (wasm_input_buffer === undefined) {
      console.warn("frame is skipping");
      return;
    }

    // get detection
    let detected = true;
    if (!render_only) {
      vmt_module._setMaxIterations(15);
      detected = vmt_module._landmarkDetection(
        width,
        height,
        wasm_input_buffer.byteOffset
      );
    }

    if (detected) {
      vmt_module._renderMakeup(width, height, wasm_input_buffer.byteOffset);

      try {
        image_data.data.set(wasm_input_buffer);

        this.resize_canvas.width = width;
        this.resize_canvas.height = height;
        this.resize_ctx.clearRect(0, 0, width, height);
        this.resize_ctx.putImageData(image_data, 0, 0);

        let isMobileBrowser = window.VmtHelper.CheckMobileBrowser();
        let outputWidth, outputHeight;
        if (isMobileBrowser) {
          outputWidth = window.TryOnEnums.OUTPUT_CANVAS_WIDTH_MOBILE;
        } else {
          outputWidth = window.TryOnEnums.OUTPUT_CANVAS_WIDTH_DESKTOP;
        }

        let aspectRatio = height / width;
        outputHeight = outputWidth * aspectRatio;

        let resizeFactor;
        resizeFactor = outputWidth / width;

        this.display_canvas.width = outputWidth;
        this.display_canvas.height = outputHeight;
        this.display_ctx.clearRect(0, 0, width, height);
        this.display_ctx.scale(resizeFactor, resizeFactor);
        this.display_ctx.drawImage(this.resize_canvas, 0, 0);
      } catch (err) {
        console.warn("unable to set image to display canvas");
        return;
      }
    }

    _freeArray(wasm_input_buffer);
  }

  canvasZoomIn(display_canvas_id) {
    let canvasWidth = document.querySelector(display_canvas_id).offsetWidth;
    let canvasHeight = document.querySelector(display_canvas_id).offsetHeight;
    document.querySelector(".canvas-container").style.width =
      canvasWidth + "px";
    document.querySelector(".canvas-container").style.height =
      canvasHeight + "px";
    console.log(`width - ${canvasWidth}, height - ${canvasHeight}`);
    var displayCanvas = document.querySelector(display_canvas_id);
    var scale = (window.TryOnEnums.SCALE_ZOOM /=
      window.TryOnEnums.SCALE_MULTIPLIER);
    if (scale <= window.TryOnEnums.MAX_SCALE_ZOOM) {
      displayCanvas.style.transform = `scale(${scale}, ${scale})`;
    } else {
      var scale = (window.TryOnEnums.SCALE_ZOOM *=
        window.TryOnEnums.SCALE_MULTIPLIER);
    }
  }

  canvasZoomOut(display_canvas_id) {
    var displayCanvas = document.querySelector(display_canvas_id);
    var scale = (window.TryOnEnums.SCALE_ZOOM *=
      window.TryOnEnums.SCALE_MULTIPLIER);
    if (scale >= window.TryOnEnums.MIN_SCALE_ZOOM) {
      displayCanvas.style.transform = `scale(${scale}, ${scale})`;
    } else {
      var scale = (window.TryOnEnums.SCALE_ZOOM /=
        window.TryOnEnums.SCALE_MULTIPLIER);
    }
  }

  clearMakeup() {
    vmt_module._resetAllMakeup();
    vmt_module._set_exclude_occlusion(false);
    this.cycleForSingleImage(true);
  }

  /** FOUNDATION */

  applyFoundation(
    r,
    g,
    b,
    a,
    mask = undefined,
    smootingCoefficent,
    finishType,
    finishIntensity,
    blendingRatio,
    shiniesss,
    maskIntensity
  ) {
    if (mask != null && mask.toLowerCase() == "foundation_conceal_1") {
      let strPtr = _stringToHeap(mask);
      vmt_module._setPerfector(strPtr, r, g, b, a);
      _freeString(strPtr);
    } else {
      vmt_module._set_exclude_occlusion(true);
      vmt_module._setFoundation(
        r,
        g,
        b,
        a,
        smootingCoefficent,
        _stringToHeap(finishType),
        finishIntensity,
        blendingRatio,
        shiniesss,
        maskIntensity
      );
    }
    this.cycleForSingleImage(true);
  }

  removeFoundation() {
    vmt_module._set_exclude_occlusion(false);
    vmt_module._resetFoundation();
    this.cycleForSingleImage(true);
  }

  /** PERFECTOR */

  applyPerfector(r, g, b, a, mask) {
    let strPtr = _stringToHeap(mask);
    vmt_module._setPerfector(strPtr, r, g, b, a);
    _freeString(strPtr);
    this.cycleForSingleImage(true);
  }

  removePerfector() {
    vmt_module._resetFoundation();
    this.cycleForSingleImage(true);
  }

  /** BLENDER */

  applyBlender(r, g, b, a) {
    vmt_module._setBlender(r, g, b, a);
    this.cycleForSingleImage(true);
  }

  removeBlender() {
    vmt_module._resetBlender();
    this.cycleForSingleImage(true);
  }

  /** BLUSH */

  applyBlush(
    r,
    g,
    b,
    a,
    mask,
    shmr_mask = null,
    shmr_intensity = null,
    shimmer_r,
    shimmer_g,
    shimmer_b
  ) {
    if (shmr_mask && shmr_intensity) {
      let strPtr0 = _stringToHeap(shmr_mask);
      vmt_module._setBlushShimmerEffect(
        strPtr0,
        shimmer_r,
        shimmer_g,
        shimmer_b,
        shmr_intensity
      );
      _freeString(strPtr0);
    }
    let strPtr1 = _stringToHeap(mask);
    vmt_module._setBlush(strPtr1, r, g, b, a);
    _freeString(strPtr1);
    this.cycleForSingleImage(true);
  }

  removeBlush() {
    vmt_module._resetBlush();
    this.cycleForSingleImage(true);
  }

  /** LIPSTICK */

  applyLipstick(
    r,
    g,
    b,
    a,
    fnsh_intensity,
    fnsh_type,
    gltr_mask = null,
    gltr_intensity = null,
    shmr_mask = null,
    shmr_intensity = null
  ) {
    if (gltr_mask && gltr_intensity) {
      let strPtr0 = _stringToHeap(gltr_mask);
      vmt_module._setLipGlitterEffect(strPtr0, gltr_intensity);
      _freeString(strPtr0);
    }
    if (shmr_mask && shmr_intensity) {
      let strPtr1 = _stringToHeap(shmr_mask);
      vmt_module._setLipShimmerEffect(strPtr1, shmr_intensity);
      _freeString(strPtr1);
    }
    vmt_module._setLipstick(r, g, b, a, fnsh_intensity, fnsh_type);
    this.cycleForSingleImage(true);
  }

  removeLipstick() {
    vmt_module._resetLipstick();
    this.cycleForSingleImage(true);
  }

  /** LIPLINER */

  applyLipliner(r, g, b, a, mask) {
    let strPtr = _stringToHeap(mask);
    vmt_module._setLipliner(strPtr, r, g, b, a);
    _freeString(strPtr);
    this.cycleForSingleImage(true);
  }

  removeLipliner() {
    vmt_module._resetLipliner();
    this.cycleForSingleImage(true);
  }

  /** HIGHLIGHTER */

  applyHighlighter(r, g, b, a, mask, shmr_mask = null, shmr_intensity = null) {
    if (shmr_mask && shmr_intensity) {
      let strPtr0 = _stringToHeap(shmr_mask);
      vmt_module._setHighlighterShimmerEffect(strPtr0, shmr_intensity);
      _freeString(strPtr0);
    }
    let strPtr1 = _stringToHeap(mask);
    vmt_module._setHighlighter(strPtr1, r, g, b, a);
    _freeString(strPtr1);
    this.cycleForSingleImage(true);
  }

  removeHighlighter() {
    vmt_module._resetHighlighter();
    this.cycleForSingleImage(true);
  }

  /** CONTOUR */

  applyContour(r, g, b, a, mask) {
    let strPtr = _stringToHeap(mask);
    vmt_module._setContour(strPtr, r, g, b, a);
    _freeString(strPtr);
    this.cycleForSingleImage(true);
  }

  removeContour() {
    vmt_module._resetContour();
    this.cycleForSingleImage(true);
  }

  /** BRONZER */

  applyBronzer(r, g, b, a, mask) {
    let strPtr = _stringToHeap(mask);
    vmt_module._setBronzer(strPtr, r, g, b, a);
    _freeString(strPtr);
    this.cycleForSingleImage(true);
  }

  removeBronzer() {
    vmt_module._resetBronzer();
    this.cycleForSingleImage(true);
  }

  /** EYEBROWS */

  applyEyebrow(r, g, b, a, mask) {
    let strPtr = _stringToHeap(mask);
    vmt_module._setEyebrow(strPtr, r, g, b, a);
    _freeString(strPtr);
    this.cycleForSingleImage(true);
  }

  removeEyebrow() {
    vmt_module._resetEyebrow();
    this.cycleForSingleImage(true);
  }

  /** EYESHADOW */

  applyEyeshadow(
    r,
    g,
    b,
    a,
    mask,
    shmr_mask = null,
    shmr_intensity = null,
    shmr_r,
    shmr_g,
    shmr_b
  ) {
    let strPtr1 = _stringToHeap(mask);
    vmt_module._setEyeshadow(strPtr1, r, g, b, a);
    _freeString(strPtr1);
    if (
      shmr_mask != null &&
      shmr_mask != "" &&
      shmr_intensity != null &&
      shmr_intensity > 0
    ) {
      let strPtr0 = _stringToHeap(shmr_mask);
      vmt_module._setEyeshadow(strPtr0, shmr_r, shmr_g, shmr_b, shmr_intensity);
      _freeString(strPtr0);
    }
    this.cycleForSingleImage(true);
  }

  removeEyeshadow() {
    vmt_module._resetEyeshadow();
    this.cycleForSingleImage(true);
  }

  /** EYELASH */

  applyEyelash(r, g, b, a, mask) {
    // let IsRealtimeTrackingIsEnabled = this.GetRealTimeTracking();
    // if (IsRealtimeTrackingIsEnabled) {
    //   vmt_module._setEyesCorrection(true);
    // } else {
    //   vmt_module._setEyesCorrection(false);
    // }
    vmt_module._setEyesCorrection(true);
    let strPtr = _stringToHeap(mask);
    vmt_module._setEyelash(strPtr, r, g, b, a);
    _freeString(strPtr);
    this.cycleForSingleImage(true);
  }

  removeEyelash() {
    vmt_module._resetEyelash();
    this.cycleForSingleImage(true);
  }

  /** EYELINER */

  applyEyeliner(r, g, b, a, mask) {
    // let IsRealtimeTrackingIsEnabled = this.GetRealTimeTracking();
    // if (IsRealtimeTrackingIsEnabled) {
    //   vmt_module._setEyesCorrection(true);
    // } else {
    //   vmt_module._setEyesCorrection(false);
    // }
    vmt_module._setEyesCorrection(true);
    let strPtr = _stringToHeap(mask);
    vmt_module._setEyeliner(strPtr, r, g, b, a);
    _freeString(strPtr);
    this.cycleForSingleImage(true);
  }

  removeEyeliner() {
    vmt_module._resetEyeliner();
    this.cycleForSingleImage(true);
  }
  /** HELPERS */
  SetRealTimeTracking(boolValue) {
    vmt_module._setRealTimeTracking(boolValue);
  }
  GetRealTimeTracking() {
    return Boolean(vmt_module._getRealTimeTracking());
  }
  /** Float from , Float to. -0.55 to 0.55 is the sweet spot */
  SetYawRange(from, to) {
    vmt_module._setYawRange(from, to);
  }
  CalculateFPS(DOMElementId) {
    let prevTime = Date.now(),
      frames = 0;

    requestAnimationFrame(function loop() {
      const time = Date.now();
      frames++;
      if (time > prevTime + 1000) {
        let fps = Math.round((frames * 1000) / (time - prevTime));
        prevTime = time;
        frames = 0;
        // document.getElementById(DOMElementId).innerText = fps;
        //console.info("FPS: ", fps);
      }

      requestAnimationFrame(loop);
    });
  }
  CheckMobileBrowser() {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }
}

if (!window.VmtHelper) {
  window.VmtHelper = new VmtHelper();
}
